import extend from 'extend';
import convert from 'convert-units';

function bestConversion (data) {
    var isMetric = (data.system !== 'imperial'),
        unitMeta = convert().describe(data.unit),
        systemValue = 0,
        target = null;

    switch (unitMeta.measure) {
    case 'length': target = isMetric ? 'km' : 'mi'; break;
    case 'mass': target = isMetric ? 'g' : 'oz'; break;
    case 'fuelConsumption': target = isMetric ? 'l/100km' : 'mpg'; break;
    }

    systemValue = convert(Math.abs(data.value)).from(data.unit).to(target);

    return convert(systemValue).from(target).toBest(extend(true, {
        exclude: ['fathom', 'ft-us', 'nMi']
    }, data.options));
}

function convertUnits (system, value, units) {
    if (!Array.isArray(units)) {
        units = [units];
    }

    var result = null,
        descriptions = [];

    units.forEach(function (unit, i) {
        var conversion;

        if (i === 0) {
            conversion = bestConversion({
                system: system,
                unit: unit,
                value: value,
                options: {
                    cutOffNumber: 1
                }
            });
        } else {
            conversion = bestConversion({
                system: system,
                unit: unit,
                value: 1,
                options: {
                    cutOffNumber: 0.2
                }
            });
        }

        if (i === 0) {
            result = conversion.val;
        } else {
            result /= conversion.val;
        }

        descriptions.push(convert().describe(conversion.unit));
    });

    if (descriptions.length === 1) {
        descriptions = descriptions[0];
    }

    return {
        value: result,
        unit: descriptions
    };
}

var _last = null;

export default {
    methods: {
        _convert: function (value, units) {
            if (arguments.length === 2) {
                _last = convertUnits(this.$store.state.measurementSystem, value, units);
            }

            return _last;
        }
    }
};
